<script>
    export default {
        props: {
            filter: {
                type: Object,
                default: {}
            }
        },
        created() {
            this.listenToEvents();
        },
        methods: {
            setValue(filterKey, filterValue) {
                this.$set(this.filter, filterKey, filterValue);
            },
            listenToEvents() {
                this.$on('set-value', (filterKey, filterValue) => {
                    this.setValue(filterKey, filterValue);

                    this.$emit('filter-changed', filterKey, filterValue);
                });
            }
        }
    }
</script>

<template>
    <div class="attribute-translation-filter">
        <slot>Slot content missing</slot>
    </div>
</template>